import axios from "@/plugins/axios";

let url = "/api/v1/uthestar/salmons";

export const salmons = {
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}